import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { DashboardLayout } from '@blumtechgroup/blum-react-core-components';
import { useQuery } from '@apollo/client';
import { selectLocationsInitQuery, Organisation } from './queries';
import { ListLocationsComponent } from '../../../../../components/Global';

type UrlParams = {
  organisation_id: string;
};

const ListLocations = (): React.ReactElement => {
  const navigate = useNavigate();

  const { organisation_id } = useParams<UrlParams>();

  const [pageState, setPageState] = useState<Organisation>({
    name: '',
  });
  const { data: locationsInitData } = useQuery(selectLocationsInitQuery(organisation_id!), { fetchPolicy: 'no-cache' });

  useEffect(() => {
    if (locationsInitData) {
      setPageState(locationsInitData.organisations_by_pk);
    }
  }, [locationsInitData]);

  const handleView = (locationId: string) => {
    navigate(`/admin/organisations/${organisation_id}/locations/${locationId}`);
  };

  const handleEdit = (locationId: string) => {
    navigate(`/admin/organisations/${organisation_id}/locations/${locationId}/edit`);
  };

  const handleCreate = () => {
    navigate(`/admin/organisations/${organisation_id}/locations/create`);
  };

  return (
    <DashboardLayout
      breadcrumbs={[
        { label: 'Admin', link: '/admin/home' },
        { label: 'Organisations', link: '/admin/organisations' },
        { label: pageState.name, link: `/admin/organisations/${organisation_id}` },
        { label: 'Hospitals' },
      ]}>
      <ListLocationsComponent organisationId={organisation_id!} handleCreate={handleCreate} handleEdit={handleEdit} handleView={handleView} />
    </DashboardLayout>
  );
};

export default ListLocations;
